import React, { createContext, useContext, useState, useEffect } from 'react';
import {
	defaultColDefination,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getCommonVendors } from 'utils/apiRequests';
import { formatNumber, getFormattedSpend } from 'utils/number';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { getRequiredCustomFilterObjectFormat } from 'CategoryManagement/utils';

const CommonVendorsContext = createContext();

const vendorString = 'common vendors';

export const CommonVendorsProvider = ({ children }) => {
	const { currency } = useContext(QueryStringContext);
	const columnDefs = [
		{ headerName: 'Vendor Name', field: 'commonVendors' },
		{ headerName: 'Business Unit', field: 'businessUnits' },
		{
			headerName: 'Vendor spend',
			field: 'vendorSpend',
			valueFormatter: params => {
				return getFormattedSpend(params.value, currency).toUpperCase();
			},
		},
		{
			headerName: 'Total Vendor spend',
			field: 'totalVendorSpend',
			valueFormatter: params => {
				return getFormattedSpend(params.value, currency).toUpperCase();
			},
		},
		{ headerName: 'AP L1Category', field: 'aP_L1Category' },
		{ headerName: 'AP L2Category', field: 'aP_L2Category' },
		{ headerName: 'AP L3Category', field: 'aP_L3Category' },
		{ headerName: 'AP L4Category', field: 'aP_L4Category' },
		{ headerName: 'Country', field: 'country' },
	];
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`No ${vendorString}`);
	const [gridData, setGridData] = useState(initialGridData);
	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		isDirect,
		isSourceable,
		taxonomyType,
		customFilters,
		customFiltersValues,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payload = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						isSourceable: isSourceable,
						aptaxonomy: isDirect,
						taxonomyType: taxonomyType,
					};
					if (
						Array.isArray(customFiltersValues) &&
						customFiltersValues.length > 0
					) {
						payload.customfilter = getRequiredCustomFilterObjectFormat(
							customFilters,
							customFiltersValues
						);
					}
					getCommonVendors(payload)
						.then(response => {
							if (response.succeeded) {
								if (response.data === null) {
									const analysisString = `0 ${vendorString}`;
									setAnalysis(analysisString);
									setGridData(prevState => ({
										...prevState,
										rowData: [],
										columnDefs: [],
										defaultColDef: defaultColDefination,
									}));
									setIsLoading(false);
								} else {
									if (response.data.length > 0) {
										const vendors = [
											...new Set(response.data.map(obj => obj.commonVendors)),
										];
										const analysisString = `${formatNumber(
											vendors.length
										)} ${vendorString}`;
										setAnalysis(analysisString);
										setGridData(prevState => ({
											...prevState,
											rowData: response.data,
											columnDefs: columnDefs,
											defaultColDef: defaultColDefination,
										}));
										setIsLoading(false);
									}
								}
							} else {
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			isDirect,
			isSourceable,
			taxonomyType,
			customFilters,
			customFiltersValues,
		]
	);

	return (
		<CommonVendorsContext.Provider value={{ isLoading, analysis, gridData }}>
			{children}
		</CommonVendorsContext.Provider>
	);
};

export const useCommonVendorsContext = () => {
	return useContext(CommonVendorsContext);
};
